import React from "react";
import { FormProps } from "Utilities/Types";
import { useTranslation } from "react-i18next";
import Error from "Components/InputsForm/Error";

const Email: React.FC<FormProps> = ({ register, errors, placeholder }) => {
  const { t } = useTranslation();

  const pattern = {
    value: /^[a-zA-Z0-9_.-]+@[a-zA-Z]+\.[a-zA-Z]{2,4}(\.[a-zA-Z]{2})?$/,
    message: t("contact.form.mail"),
  };
  return (
    <div className="form_box mail">
      <label htmlFor="email">{t("contact.form.mail")} *</label>
      <input
        type="text"
        autoComplete="email"
        className={
          errors.email ? "input input-focus invalid" : "input input-focus"
        }
        id="email"
        {...register("email", { required: true, pattern })}
        placeholder={placeholder}
      />
      <Error error={errors.email} />
    </div>
  );
};

export default Email;
